import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import EditLocation from './EditLocation'; // Adjust the path as necessary

const stripePromise = loadStripe(process.env.REACT_APP_SUPERADMIN_STRIPE_PUBLIC_KEY || "");

const EditLocationWrapper = (props: any) => (
  <Elements stripe={stripePromise}>
    <EditLocation {...props} />
  </Elements>
);

export default EditLocationWrapper;
